import React, { useEffect, useState, useContext } from 'react'
import CustomImage from '../../components/customImage/customImage'
import useTemplateHook from '../../components/template/templateHook'
import { useTranslation } from 'react-i18next'
import useAxios from 'axios-hooks'
import { withTheme } from 'theming'
import { AppContext } from '../../context/app'
import SocialAuth from '../../components/socialAuth'

const EclipseSignInModal = (props) => {
  let { isEdit = false, theme, data, setModalState } = props

  const { t } = useTranslation()
  const { setModalType } = useContext(AppContext)

  const [loginEmail, setLoginEmail] = useState('')
  const [loginPassword, setLoginPassword] = useState('')
  const [errorData, setErrorData] = useState({})
  const [hoverState, setHoverState] = useState('')
  const [show, setShow] = useState(false)

  const {
    getTemplateImage,
    setLoader,
    setOpenForgotPasswordModal,
    setOpenLoginModal,
    setUser,
    LOGIN_API,
    EditIcon,
  } = useTemplateHook()

  const [{ data: loginRes, loading: loginResLoading }, loginCall] = useAxios(
    {
      url: LOGIN_API,
      method: 'post',
    },
    { manual: true },
  )

  // Show modal with delay on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (loginEmail.trim().length === 0) {
      isFormValid = false
      temp.loginEmail = `${t('email_empty')}!`
    }

    if (loginPassword.trim().length === 0) {
      isFormValid = false
      temp.loginPassword = `${t('password_empty')}!`
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleLogin = async () => {
    if (isEdit) return

    if (validateInfo()) {
      loginCall({
        data: {
          email_id: loginEmail,
          password: loginPassword,
        },
      })
    }
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target

    if (errorData[`${name}`]) {
      delete errorData[`${name}`]
      setErrorData({ ...errorData })
    }
    func(value)
  }

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      setOpenLoginModal(false)
      setModalType('login') // Reset to login mode
    }, 400)
  }

  const emptyState = () => {
    setLoginEmail('')
    setLoginPassword('')
    setErrorData({})
  }

  const switchToRegister = () => {
    emptyState()
    setModalType('register')
  }

  useEffect(() => {
    if (loginRes && loginRes.success) {
      setUser(loginRes?.data)
      emptyState()
      handleClose()
    }
  }, [loginRes])

  useEffect(() => {
    setLoader(loginResLoading)
  }, [loginResLoading])

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return tempArr && tempArr.length > 0
      ? tempArr[0].value
        ? tempArr[0].value
        : defaultValue
      : defaultValue
  }

  const handleModal = (modalData) => {
    setModalState({ ...modalData })
  }

  return (
    <div
      style={{
        backgroundColor: `${theme.c1}90`,
        opacity: show ? 1 : 0,
        transition: 'opacity 0.4s ease',
      }}
      className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
    >
      <div
        style={{
          transform: show ? 'scale(1)' : 'scale(0.9)',
          opacity: show ? 1 : 0,
          transition: 'all 0.4s ease',
        }}
        className="relative  my-6 w-11/12 md:w-10/12 lg:w-8/12 xl:w-5/12"
      >
        <div
          className={`${isEdit && hoverState && 'component-hover-class'} relative`}
          onMouseEnter={() => handleHoverItems(`TOP`)}
          onMouseLeave={() => handleHoverItems('')}
        >
          {isEdit && hoverState.length > 0 && (
            <div
              className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-4 right-4 z-10 flex justify-center items-center cursor-pointer"
              onClick={() => handleModal({ modalKey: 'eclipseSignInModal', data: data })}
            >
              <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
            </div>
          )}

          <div
            style={{
              background: getStyleValue('component_background', 'primary_color', theme.c10),
              boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.8), 0 6px 20px 0 rgba(0, 0, 0, 0.80)',
            }}
            className="shadow-lg relative flex flex-col p-8"
          >
            {/* Close Button */}
            <div className="p-2 object-right-top absolute right-0 top-0">
              <button
                className="float-right mr-2"
                onClick={() => {
                  handleClose()
                  emptyState('login')
                }}
              >
                <span
                  style={{ color: getStyleValue('login_heading', 'color', theme.c5) }}
                  className=" h-6 w-6 text-2xl"
                >
                  ×
                </span>
              </button>
            </div>

            {/* Content */}
            <div className="w-full flex justify-center">
              <div className="w-[80%] md:w-[400px] xl:w-[500px] pb-10 xl:pb-0  flex flex-col items-center">
                {/* Logo */}
                <div
                  className={`w-full flex justify-center ${
                    isEdit && hoverState === 'IMAGE' && 'component-hover-class'
                  } relative`}
                  onMouseOver={() => handleHoverItems('IMAGE')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'IMAGE' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'logoModal',
                          data: data,
                          modalSpecificData: {
                            imgWidth: 255,
                            imgHeight: 101,
                            divWidth: '17.67rem',
                            divHeight: '7rem',
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}
                  <CustomImage
                    imageUrl={getTemplateImage(data?.logo)}
                    imgClass="w-[146px] lg:w-[200px]"
                    loaderClass=""
                    imgAlt={'logo'}
                  />
                </div>

                {/* Login Text */}
                <div
                  className={`w-full ${
                    isEdit && hoverState === 'LOGIN_TEXT' && 'component-hover-class'
                  } mt-5 relative`}
                  onMouseOver={() => handleHoverItems('LOGIN_TEXT')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'LOGIN_TEXT' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'loginTextModal',
                          data: data,
                          modalSpecificData: {
                            stylesConfigArr: ['login_heading', 'login_description'],
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}
                  <p
                    style={{
                      color: getStyleValue('login_heading', 'color', theme.c5),
                      fontFamily: getStyleValue('login_heading', 'font', ''),
                      textAlign: getStyleValue('login_heading', 'alignment', 'center'),
                    }}
                    className={`mb-0 text-base lg:text-xl font-bold ${getStyleValue(
                      'login_heading',
                      'font_format',
                      '',
                    )}`}
                  >
                    {data?.login_text}
                  </p>
                  <p
                    style={{
                      color: getStyleValue('login_description', 'color', theme.c3),
                      fontFamily: getStyleValue('login_description', 'font', ''),
                      textAlign: getStyleValue('login_description', 'alignment', 'center'),
                    }}
                    className={`mb-0 mt-3 text-xs ${getStyleValue(
                      'login_description',
                      'font_format',
                      '',
                    )}`}
                  >
                    {data?.login_description}
                  </p>
                </div>

                {/* Input Fields */}
                <div
                  className={`w-full ${
                    isEdit && hoverState === 'INPUT' && 'component-hover-class'
                  } mt-6 relative`}
                  onMouseOver={() => handleHoverItems('INPUT')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'INPUT' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'inputModal',
                          data: data,
                          modalSpecificData: {
                            stylesConfigArr: [
                              'email_password_text',
                              'email_password_input',
                              'remember_text',
                            ],
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}

                  <p
                    style={{
                      color: getStyleValue('email_password_text', 'color', theme.c4),
                      fontFamily: getStyleValue('email_password_text', 'font', ''),
                      textAlign: getStyleValue('email_password_text', 'alignment', ''),
                    }}
                    className={`${getStyleValue(
                      'email_password_text',
                      'font_format',
                      '',
                    )} mb-0 text-xs lg:text-sm`}
                  >
                    {data?.email_text}
                  </p>
                  <input
                    type="email"
                    name="loginEmail"
                    value={loginEmail}
                    onChange={(e) => handleChange(e, setLoginEmail)}
                    style={{
                      background: getStyleValue(
                        'email_password_input',
                        'background_color',
                        'transparent',
                      ),
                      color: getStyleValue('email_password_input', 'text_color', theme.c4),
                      border: `0.5px solid ${getStyleValue(
                        'email_password_input',
                        'border_color',
                        theme.c4,
                      )}`,
                    }}
                    className="text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                  />
                  {errorData?.loginEmail && (
                    <div className="error-message">
                      <p className="text-red-500 text-xs mt-1">{errorData.loginEmail}</p>
                    </div>
                  )}

                  <p
                    style={{
                      color: getStyleValue('email_password_text', 'color', theme.c4),
                      fontFamily: getStyleValue('email_password_text', 'font', ''),
                      textAlign: getStyleValue('email_password_text', 'alignment', ''),
                    }}
                    className={`${getStyleValue(
                      'email_password_text',
                      'font_format',
                      '',
                    )} mb-0 mt-3 text-xs lg:text-sm`}
                  >
                    {data?.password_text}
                  </p>
                  <input
                    type="password"
                    name="loginPassword"
                    value={loginPassword}
                    onChange={(e) => handleChange(e, setLoginPassword)}
                    style={{
                      background: getStyleValue(
                        'email_password_input',
                        'background_color',
                        'transparent',
                      ),
                      color: getStyleValue('email_password_input', 'text_color', theme.c4),
                      border: `0.5px solid ${getStyleValue(
                        'email_password_input',
                        'border_color',
                        theme.c4,
                      )}`,
                    }}
                    className="text-xs lg:text-sm rounded block w-full p-1 mt-1 focus:outline-none"
                  />
                  {errorData?.loginPassword && (
                    <div className="error-message">
                      <p className="text-red-500 text-xs mt-1">{errorData.loginPassword}</p>
                    </div>
                  )}

                  <div className="mt-4 flex justify-between items-center">
                    <div className="flex items-center">
                      <input
                        id="remember"
                        type="checkbox"
                        defaultChecked={true}
                        className="h-4 w-4"
                      />
                      <label
                        htmlFor="remember"
                        style={{
                          color: getStyleValue('remember_text', 'color', theme.c4),
                          fontFamily: getStyleValue('remember_text', 'font', ''),
                        }}
                        className={`ml-2 text-xs lg:text-sm ${getStyleValue(
                          'remember_text',
                          'font_format',
                          '',
                        )}`}
                      >
                        {data?.remember_text}
                      </label>
                    </div>
                  </div>
                </div>

                {/* Button Section */}
                <div
                  className={`mt-6 w-full text-center ${
                    isEdit && hoverState === 'BUTTON' && 'component-hover-class'
                  } relative`}
                  onMouseOver={() => handleHoverItems('BUTTON')}
                  onMouseLeave={() => handleHoverItems('TOP')}
                >
                  {hoverState === 'BUTTON' && (
                    <div
                      className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                      onClick={() =>
                        handleModal({
                          modalKey: 'buttonModal',
                          data: data,
                          modalSpecificData: {
                            stylesConfigArr: ['login_button', 'account_text', 'forgot_text'],
                          },
                        })
                      }
                    >
                      <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                    </div>
                  )}

                  <button
                    style={{
                      backgroundImage: `linear-gradient(to ${getStyleValue(
                        'login_button',
                        'gradient',
                        'left',
                      )}, ${getStyleValue(
                        'login_button',
                        'primary_color',
                        theme.c5,
                      )}, ${getStyleValue('login_button', 'secondary_color', theme.c5)})`,
                      color: getStyleValue('login_button', 'color', theme.c7),
                    }}
                    className="w-full py-2 rounded xl:text-base text-sm font-medium focus:outline-none"
                    onClick={handleLogin}
                  >
                    {data?.login_button_text}
                  </button>

                  <p
                    className={`mb-0 mt-6 text-xs lg:text-sm ${getStyleValue(
                      'account_text',
                      'font_format',
                      '',
                    )}`}
                    style={{
                      color: getStyleValue('account_text', 'color', theme.c3),
                      fontFamily: getStyleValue('account_text', 'font', ''),
                      textAlign: getStyleValue('account_text', 'alignment', 'center'),
                    }}
                  >
                    {data?.account_text}{' '}
                    <span
                      className="font-semibold cursor-pointer"
                      style={{
                        color: getStyleValue('account_text', 'register_text_color', theme.c5),
                      }}
                      onClick={switchToRegister}
                    >
                      {data?.register_text}
                    </span>
                  </p>

                  <p
                    className={`mb-0 mt-5 italic cursor-pointer text-xs lg:text-sm ${getStyleValue(
                      'forgot_text',
                      'font_format',
                      '',
                    )}`}
                    style={{
                      color: getStyleValue('forgot_text', 'color', theme.c5),
                      fontFamily: getStyleValue('forgot_text', 'font', ''),
                      textAlign: getStyleValue('forgot_text', 'alignment', 'center'),
                    }}
                    onClick={() => {
                      handleClose()
                      setOpenForgotPasswordModal(true)
                    }}
                  >
                    {data?.forgot_text}
                  </p>
                </div>

                <div className="w-full">
                  <SocialAuth
                    textColor={getStyleValue('email_password_text', 'color', theme.c4)}
                    borderColor={getStyleValue('login_button', 'primary_color', theme.c5)}
                    isModal
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTheme(EclipseSignInModal)
